var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn_app btn prave_tlacitko prave_tlacitko_fix",staticStyle:{"margin-top":"25px"},attrs:{"href":_vm.getLinkValue}},[_vm._v(" "+_vm._s(_vm.textLink)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }